// https://formkit.com/essentials/examples
const isCheckboxAndRadioMultiple = (node) => (node.props.type === "checkbox" || node.props.type === "radio") &&
    node.props.options;
export default function addAsteriskPlugin(node) {
    node.on("created", () => {
        if (!node.props.definition || !node.context || node.type !== "input") {
            return;
        }
        const inputTypeUniqueKey = node.props.definition.schemaMemoKey || node.context.type;
        node.props.definition.schemaMemoKey = `required_${isCheckboxAndRadioMultiple(node) ? 'multi_' : ""}${inputTypeUniqueKey}`;
        node.context.isRequired = node.props.parsedRules.some((rule) => rule.name === "required");
        node.on('prop:validation', () => {
            if (!node.context)
                return;
            node.context.isRequired = node.props.parsedRules.some((rule) => rule.name === 'required');
        });
        // it would be better to have a proper type check here, but this plugin comes straight
        // from the FormKit site, so we'll just assert this and assume they know what they're doing
        const schemaFn = node.props.definition
            .schema;
        node.props.definition.schema = (sectionsSchema = {}) => {
            sectionsSchema[isCheckboxAndRadioMultiple(node) ? 'legend' : 'label'] = {
                children: ['$label', {
                        $el: 'span',
                        if: '$isRequired',
                        attrs: {
                            class: '$classes.asterisk',
                        },
                        children: ['*']
                    }]
            };
            return schemaFn(sectionsSchema);
        };
    });
}
